module.exports = __webpack_public_path__ + "static/img/b24.7f56190.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b24.jpg
// module id = Fwqp
// module chunks = 1